module.exports = __webpack_public_path__ + "img/right.c3cfb991.png";